import script from "./ProjectResourceCostsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectResourceCostsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectResourceCostsPage.vue?vue&type=style&index=0&id=a9d4872c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9d4872c"]])

export default __exports__